// 巡检报告
import { useState, useEffect, useRef } from 'react'
import { Table, Spin, message, Radio } from 'antd'
import HeaderBuilder from '@/components/TableBuilder/HeaderBuilder';
import SortOrFilter from '@/components/TableBuilder/SortOrFilter';
import { useNavigate } from 'react-router-dom'
import { InsReportList_Get, GetReport } from "@/services/inspection_report.js"; // 引入Ajax
import local from '@/utils/local'

import DownloadFile from './download_file';

export default function Inspector () {
  const navigate = useNavigate()
  const limitsAuthority = useRef()//权限列表
  const token = local.get('cruise_m350_token');
  /**
   * data
   * */
  const [spinningLoading, _spinningLoading] = useState(false);
  const [total, _total] = useState(0);
  const [List, _List] = useState();
  const [searchCriteria, _searchCriteria] = useState({
    title: '',
    order: '',
    type: 1,
    status: '',
    current: 1,
    pageSize: 10,
  });

  //下载文件弹窗参数
  const modelType = useRef(0);//弹窗类型 1、下载报告  2、导出图片
  const [modelOpen, setModelOpen] = useState(false);
  const [modelTitle, setModelTitle] = useState('');
  const [modelBtnLoading, setModelBtnLoading] = useState(false);
  const [modelContent, setModelContent] = useState('');//内容

  const fileName = useRef('');// 文件名称
  const downloadFileUrl = useRef('');// 文件地址

  useEffect(() => {
    limitsAuthority.current = JSON.parse(local.get('cruise_m350_permissionsArr'))
    let sea = searchCriteria
    sea.type = (limitsAuthority.current)?.indexOf(116) > -1 ? 1 : (limitsAuthority.current)?.indexOf(118) > -1 ? 6 : (limitsAuthority.current)?.indexOf(117) > -1 ? 2 : 0
    _searchCriteria({ ...sea })
    getList(sea)
  }, []);// eslint-disable-line

  /**
   * methods
  * */
  // 获取数据
  const getList = async (values) => {
    _spinningLoading(true)
    const res = await InsReportList_Get({
      access_token: token || '',
      title: values.title,
      type: values.type,
      order: values.order,
      status: values.status,
      page: values.current,
      perpage: values.pageSize,
    });
    _spinningLoading(false)
    if (res.ret == 200) {// eslint-disable-line
      if (res.data.items.length != 0) {// eslint-disable-line
        res.data.items.forEach((item, index) => {
          item.key = index;
          item.c_list.forEach((val, ndx) => {
            val.key = ndx;
            val.CompanyID = item.CompanyID;
            val.pipe_name = item.pipe_name;
            val.statid = item.id;
          });
        });
      }
      _List(res.data.items || []);
      _total(res.data.total || 0)
    }
  };

  //获取报告
  const downloadReport = async (num, id) => {
    setModelOpen(true);
    setModelBtnLoading(true);
    modelType.current = 1;
    setModelTitle('下载报告文件');
    setModelContent('正在从服务器获取报告文件，请稍等...');
    const res = await GetReport({
      access_token: token,
      statid: id,
      insId: num
    });
    console.log(res);
    setModelContent('报告文件已准备，点击按钮下载');
    setModelBtnLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      setModelOpen(false);
      return;
    }
    message.success('获取报告成功');
    if (res.data.reportfile_url && modelType.current === 1) {
      fileName.current = res.data.file_name || '巡检报告';
      downloadFileUrl.current = res.data.reportfile_url;
    }
  }

  // 分页、排序、筛选变化时触发
  const handleTableChange = (newPagination, filters, sorter) => {
    let searchBefore = { ...searchCriteria };
    // 分页
    searchBefore.current = newPagination.current;
    searchBefore.pageSize = newPagination.pageSize;
    _searchCriteria({ ...searchBefore })
    getList(searchBefore) //加载列表
  };

  const columns = [
    {
      title: '管线/单元名称',
      // issearch: true,
      dataIndex: 'pipe_name',
    },
    {
      title: '总里程(km)',
      width: 150,
      dataIndex: 'pipe_len',
    },
    {
      title: '巡检起止',
      dataIndex: 'start_time',
      width: 200,
      // sorter: {
      //     compare: (a, b) => a.addtime - b.addtime,
      //     multiple: 1,
      // },
      render: (_, item, index) => {
        return (
          <div>
            <div style={{ display: (item.start_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.start_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.start_time.split(' ')[1]}</span>
            </div>
            <div style={{ display: (item.end_time) ? 'none' : 'block', paddingLeft: '50px' }}>
              <span className='coL0_85' style={{ color: (item.end_time) ? 'black' : 'red' }}>~</span>
            </div>
            <div className='' style={{ display: (item.end_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.end_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.end_time.split(' ')[1]}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: '下载报告',
      dataIndex: 'reportfile',
      width: 100,
      align: 'center',
      render: (text, record) => (
        <div style={{ display: (record.generate_report) ? 'block' : 'none', color: '#1890FF' }} className='curPointer'
          onClick={() => {
            // , insIds: item.insIds
            downloadReport(0, record.id);
          }}>
          下载报告
        </div>
      ),
    },
  ];

  //子表格
  const columns_c = [
    {
      issearch: true,
      dataIndex: 'line_name',
    },
    {
      width: 150,
      dataIndex: 'pipe_len',
      render: (text, item, index) => {
        return (
          <div>
            {
              text
                ? <div >{text}</div>
                : <div className='opa45'>-</div>
            }
          </div>
        );
      },
    },
    {
      issearch: true,
      dataIndex: 'start_time',
      width: 200,
      render: (_, item, index) => {
        return (
          <div>
            <div style={{ display: (item.start_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.start_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.start_time.split(' ')[1]}</span>
            </div>
            <div style={{ display: (item.end_time) ? 'none' : 'block', paddingLeft: '50px' }}>
              <span className='coL0_85' style={{ color: (item.end_time) ? 'black' : 'red' }}>~</span>
            </div>
            <div className='' style={{ display: (item.end_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.end_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.end_time.split(' ')[1]}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: '报告',
      dataIndex: '',
      width: 100,
      align: 'center',
      render: (text, record) => (
        <div style={{ display: (record.generate_report) ? 'block' : 'none', color: '#1890FF' }} className='curPointer'
          onClick={() => {
            downloadReport(record.insIds, record.statid);
          }}>
          查看
        </div>
      ),
    },

  ]

  return (
    <div className="padd_24 flex-col hei100 tablebackcol" style={{ overflowY: 'auto' }}>
      <a id='a_report' href='undefined' download="巡检报告.docx" style={{ display: 'none' }}>
        查看
      </a>
      <Spin spinning={spinningLoading}>
        <div className='padd_24 flex-auto backcol'>
          <Radio.Group
            className='marB16'
            optionType="button"
            buttonStyle="solid"
            value={searchCriteria.type}
            onChange={(e) => {
              let sea = searchCriteria
              sea.type = e.target.value
              _searchCriteria({ ...sea })
              getList(sea)
            }}
          >
            <Radio style={{ display: (limitsAuthority.current)?.indexOf(116) > -1 ? `` : `none` }} value={1}>常规巡检</Radio>
            <Radio style={{ display: (limitsAuthority.current)?.indexOf(118) > -1 ? `` : `none` }} value={6}>综合巡检</Radio>
            <Radio style={{ display: (limitsAuthority.current)?.indexOf(117) > -1 ? `` : `none` }} value={2}>高危巡检</Radio>
            <Radio style={{ display: (limitsAuthority.current)?.indexOf(129) > -1 ? `` : `none` }} value={4}>定点巡检</Radio>

          </Radio.Group>
          <Table
            columns={HeaderBuilder(columns)}
            dataSource={List}
            expandable={{
              expandedRowRender: (record) => (
                <Table showHeader={false} pagination={false} columns={columns_c} dataSource={record.c_list} />
              )
            }}
            pagination={{
              total: total,
              current: searchCriteria.current,
              pageSize: searchCriteria.pageSize,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              showQuickJumper: true,
              showSizeChanger: true,
            }}
            onChange={handleTableChange}
          />

        </div>
      </Spin>

      <DownloadFile open={modelOpen} btnLoading={modelBtnLoading} title={modelTitle}
        content={modelContent}
        fileName={fileName.current}
        downloadFileUrl={downloadFileUrl.current}
        close={() => {
          setModelOpen(false);
        }}
      ></DownloadFile>
    </div>
  )
}
